export enum GameType {
  KingOfTokyo = 'KingOfTokyo',
  Catan = 'Catan',
}

export interface Game {
  id: string;
  gameType: GameType;
  lookup: string;
  hasJoined: boolean;
}
